import PropTypes from "prop-types"
import { Button, Popover, Typography } from "antd"
import { PaperClipOutlined } from "@ant-design/icons"
import { getDocumentAws } from "../../../../helpers"
import { useAuth } from "../../../../contexts/auth"
import { useMutation } from "@apollo/client"
import { createDownloadLog } from "../../../../graphql/submission/mutations/createDownloadLog"

/**
 * @param {{ id: string, url: string, name: string }[]} documents
 * @param {{ id: string, url: string, name: string }[]} paymentDocuments
 */
export function Documents ({ documents = [], paymentDocuments = [] }) {
  
  const { user } = useAuth() || {}
  const loggedUser= user?.claims?.role
  const restricRoles = ["IMPLEMENTER","IMPLEMENTER_EVALUATOR","IMPLEMENTER_FINANCIAL_MONITOR", 
  "IMPLEMENTER_TECHNICAL_MONITOR","ADMIN_EVALUATOR","ADMIN_ASSISTANT","IMPLEMENTER_COORDINATOR"]
  const isRestricted = restricRoles.includes(loggedUser)

  const auth = useAuth()
  const userAuthDownload = auth?.user?.claims ?? {}

  /** Function to register data of downloaded documents **/

  const handleDownload = (name ) => {

    if (!userAuthDownload) {
      console.error("No user information available")
      return
    }

    const downloadInfo = {
      email: userAuthDownload.email,
      userName: userAuthDownload.name,
      role: userAuthDownload.role,
      uid: userAuthDownload.user_id,
      documentName: name,
      //type: file.type
    }

    trackDownload({
      variables: { data: downloadInfo }
    })
      .catch((error) => {
        console.error(error)
      })
  }

  const [trackDownload] = useMutation(createDownloadLog)

  return <div style={CONTAINER_STYLE}>
    <div>Documentos</div>
    <Popover
      trigger="click"
      content={() => {
        return (
          <div>
            <Typography.Text>Documentos de ministración</Typography.Text>
            {documents.map(doc => (

              <a 
                href="#" 
                rel="noopener noreferrer"
                style={{
                  display: "block",
                  color: isRestricted ? "gray" : "blue",
                  cursor: isRestricted ? "not-allowed" : "pointer",
                  pointerEvents: isRestricted ? "none" : "auto"}}
                    onClick={(e) => { 
                      e.preventDefault(); 
                      handleDownload(doc.name)
                      getDocumentAws(doc.url) }}
                key={`documentItem_${doc.id} 1`}
              >
                {doc.name}
              </a>
              
            ))}
            <br />
            <Typography.Text>Documentos de pago</Typography.Text>
            {paymentDocuments.map(doc => (
              <a
                href='#'
                onClick={(e) => { 
                  e.preventDefault(); 
                  handleDownload(doc.name)
                  getDocumentAws(doc.url) }}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: "block",
                  color: isRestricted ? "gray" : "blue",
                  cursor: isRestricted ? "not-allowed" : "pointer",
                  pointerEvents: isRestricted ? "none" : "auto"}}
                key={`documentItem_${doc.id} 2`}>
                {doc.name}
              </a>
            ))}
          </div>
        )
      }}>
      <Button
        shape="circle"
        icon={<PaperClipOutlined />} />
    </Popover>
  </div>
}

const CONTAINER_STYLE = {
  gap: "10px",
  display: "flex",
  alignItems: "center",
  flexDirection: "row",
  justifyContent: "center"
}


Documents.propTypes = {
  documents: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    url: PropTypes.string,
    name: PropTypes.string
  })),
  paymentDocuments: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    url: PropTypes.string,
    name: PropTypes.string
  }))
}
